module.exports = __webpack_public_path__ + "media/img/logo-a8925a302c93e90fc0e8edc054776113.svg";